// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"284":"413b83843c409412b45a0c2692fc674f","398":"03dca859a7bc001ac5312cff097ab437"}[chunkId] + ".js";
};